import { baseFetchToken } from './BaseSaga'
import SectionActions from '../Redux/SectionRedux'
import { getToken } from '../Services/GetToken'

export function * getSection (api, action) {
  yield baseFetchToken(
    api.getSection,
    action.data,
    getToken,
    SectionActions.getSectionSuccess,
    SectionActions.getSectionFailure
  )
}

export function * postSection (api, action) {
  yield baseFetchToken(
    api.postSection,
    action.data,
    getToken,
    SectionActions.postSectionSuccess,
    SectionActions.postSectionFailure
  )
}

export function * putSection (api, action) {
  yield baseFetchToken(
    api.putSection,
    action.data,
    getToken,
    SectionActions.putSectionSuccess,
    SectionActions.putSectionFailure
  )
}

export function * deleteSection (api, action) {
  yield baseFetchToken(
    api.deleteSection,
    action.data,
    getToken,
    SectionActions.deleteSectionSuccess,
    SectionActions.deleteSectionFailure
  )
}

export function * postSubSection (api, action) {
  yield baseFetchToken(
    api.postSubSection,
    action.data,
    getToken,
    SectionActions.postSubSectionSuccess,
    SectionActions.postSubSectionFailure
  )
}

export function * putSubSection (api, action) {
  yield baseFetchToken(
    api.putSubSection,
    action.data,
    getToken,
    SectionActions.putSubSectionSuccess,
    SectionActions.putSubSectionFailure
  )
}

export function * deleteSubSection (api, action) {
  yield baseFetchToken(
    api.deleteSubSection,
    action.data,
    getToken,
    SectionActions.deleteSubSectionSuccess,
    SectionActions.deleteSubSectionFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/SectionSagas.js